import request from '@/utils/request'

// 添加字典
export function addDictionary(data) {
  return request({
    url: 'api/sys_dict/add_sys_dict',
    method: 'post',
    data: data
  })
}

// 更新字典
export function updateDictionary(data) {
  return request({
    url: 'api/sys_dict/update_sys_dict',
    method: 'post',
    data: data
  })
}

// 用于展示列表
export function dictionaryList(data) {
  return request({
    url: 'api/sys_dict/list_sys_dict',
    method: 'get',
    params: data
  })
}

// 管理员字典列表
export function adminDictionaryList(type) {
  return request({
    url: 'api/sys_dict/query_sys_dict_admin',
    method: 'get',
    params: {
      dictType: type
    }
  })
}

// 用户字典列表
export function userDictionaryList(type) {
  return request({
    url: 'api/sys_dict/query_sys_dict',
    method: 'get',
    params: {
      dictType: type
    }
  })
}

/**
 * 删除字典
 * @param {string} str
 */
export function delDictionary(data) {
  return request({
    url: 'api/sys_dict/del_sys_dict',
    method: 'post',
    data: data
  })
}

/**
 * 通过字典名和值查询label
 * @param {string} str
 */
export function getLabelByValueAndDic(params) {
  return request({
    url: 'api/sys_dict/query_sys_dict_value',
    method: 'get',
    params
  })
}

/**
 * 通过字典名和label模糊搜索
 * @param {string} str
 */
export function getListByLabelAndDic(params) {
  return request({
    url: 'api/sys_dict/search_sys_dict_label',
    method: 'get',
    params
  })
}
/**
 * 通过字典名和label模糊搜索
 * @param {string} str
 */
export function getListByLabelAndDicWithDelete(params) {
  return request({
    url: 'api/sys_dict/search_sys_dict_label_with_delete',
    method: 'get',
    params
  })
}

/**
 * 通过字典名和所有值查询label列表
 * @param {string} str
 */
export function getLabelListByValuesAndDic(params) {
  return request({
    url: 'api/sys_dict/query_sys_dict_value_batch',
    method: 'get',
    params
  })
}

export function getLabelListByValuesAndDicWithDelete(params) {
  return request({
    url: 'api/sys_dict/query_sys_dict_value_batch_with_delete',
    method: 'get',
    params
  })
}

export function getAllDicList(params) {
  return request({
    url: 'api/sys_dict/query_sys_dict_batch',
    method: 'get',
    params
  })
}
